import React, { useState, useRef } from 'react';
import Webcam from 'react-webcam';
import { useContext } from 'react';
import { AppContext } from '../context.js';

function VideoRecorder() {
  const [isRecording, setIsRecording] = useState(false);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const webcamRef = useRef(null);
  const mediaRecorderRef = useRef(null);

  const { setVideoData } = useContext(AppContext);



  const handleStartRecording = () => {
    setIsRecording(true);
    setRecordedChunks([]);

    const stream = webcamRef.current.stream;
    mediaRecorderRef.current = new MediaRecorder(stream);

    mediaRecorderRef.current.ondataavailable = event => {
      if (event.data.size > 0) {

        setRecordedChunks(prevChunks => [...prevChunks, event.data]);
        // setVideoData(prevChunks => [...prevChunks, event.data]);
      }
    };

    mediaRecorderRef.current.start();
  };

  const handleStopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      ShareData();
    }
  };

  const handleDownload = () => {
    const blob = new Blob(recordedChunks, { type: 'video/webm' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'recorded-video.webm';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const ShareData = () => {
    const blob = new Blob(recordedChunks, { type: 'video/webm' });
    const url = URL.createObjectURL(blob);
    setVideoData(url);

  };

  console.log(recordedChunks, "this is video Recording chunks")
  return (
    <div>
      <Webcam
        audio={false}
        mirrored={true}
        ref={webcamRef}
        videoConstraints={{ width: 1280, height: 720, facingMode: 'user' }}
      />

      {isRecording ? (
        <button onClick={handleStopRecording}>Stop Recording</button>
      ) : (
        <button onClick={handleStartRecording}>Start Recording</button>
      )}

      {recordedChunks.length > 0 && (
        <button onClick={handleDownload}>Download Recording</button>
      )}
    </div>
  );
}

export default VideoRecorder;
